<template>
  <div style="border: 1px solid #ccc">
    <Toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editor"
      :defaultConfig="toolbarConfig"
      :mode="mode"
    />
    <Editor
      style="height: 500px; overflow-y: hidden"
      v-model="html"
      :defaultConfig="editorConfig"
      :mode="mode"
      @onCreated="onCreated"
      @onChange="onChange"
    />
  </div>
</template>
<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { i18nChangeLanguage } from '@wangeditor/editor'
const baseUrl = process.env.VUE_APP_BASE_API
export default {
  components: { Editor, Toolbar },
  props: {
    value: {
      type: String,
      default: ''
    },
    config: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    const self = this
    return {
      url_: baseUrl + '/imgs/',
      editor: null,
      html: '',
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            server: baseUrl + '/common/local/file/upload',
            fieldName: 'file',
            meta: {
              folderName: 'imgs'
            },
            headers: {
                'Authorization': `Bearer ${self.$store.state.user.token}`
            },
            allowedFileTypes: ['image/*'],
            // 自定义插入图片
            customInsert (res, insertFn) { // TS 语法
              // customInsert(res, insertFn) {                  // JS 语法
              // res 即服务端的返回结果
              console.log(res, '58>>>>>>>>>>>')
              if (res.code !== '20001') {
                self.$message.error(res.message)
                return
              }
              // 从 res 中找到 url alt href ，然后插入图片
              insertFn(res.data)
            }
          },
          uploadVideo: {
            server: baseUrl + '/common/local/file/upload',
            fieldName: 'file',
            meta: {
              folderName: 'video'
            },
            headers: {
                'Authorization': `Bearer ${self.$store.state.user.token}`
            },
            maxFileSize: 50 * 1024 * 1024, // 50M
            allowedFileTypes: ['video/*'],
            customInsert (res, insertFn) { // TS 语法
              // customInsert(res, insertFn) {                  // JS 语法
              // res 即服务端的返回结果
              console.log(res)
              if (res.code !== '20001') {
                self.$message.error(res.message)
                return
              }
              // 从 res 中找到 url alt href ，然后插入图片
              insertFn(res.data)
            }
          }
        },
        ...this.config
      },
      mode: 'default' // or 'simple'
    }
  },
  watch: {
    value: {
      handler (value) {
        console.log(value)
        this.html = value
      },
      immediate: true
    }
  },
  methods: {
    onCreated (editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    onChange (editor) {
      this.$emit('input', editor.isEmpty() ? '' : this.html)
    }
  },
  created() {
    i18nChangeLanguage('en')
  },
  mounted () {

  },
  beforeDestroy () {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
